.modal {
  :global {
    .ant-modal-content {
      display: flex;
      min-height: calc(100vh - 80px);
      flex-direction: column;
    }

    .ant-modal-body {
      display: flex;
      flex: 1;
      flex-direction: column;
    }
  }

  .pdfViewer {
    position: relative;

    iframe {
      top: 55px;
    }
  }
}

.imageWrapper {
  display: none;
}
